<div class="address-grid">
  @if (customer) {
    <div class="item card text-center">
      <div class="card-header selected-card-header">Adresse de facturation</div>
      <div class="card-body">
        <div>{{ customer.company ? customer.company : '&nbsp;' }}</div>
        <div class="bold-label-text pt-2">{{ customer.civility }} {{ customer.lastName }} {{ customer.firstName }}</div>
        <div id="billing-address-street">{{ customer.street }}</div>
        <div id="billing-address-complement">{{ customer.addressComplement }}</div>
        <div id="billing-address-zip-city" class="bold-label-text">{{ customer.zipCode }} {{ customer.city }}</div>
        <div id="billing-address-placename">{{ customer.placeName ? customer.placeName : '&nbsp;' }}</div>
        <p class="dummy-placename">&nbsp;</p>
      </div>
      <button
        id="modify-billing-address"
        type="button"
        class="cta_btn level_2 address"
        (click)="displayPasswordModal()"
        >Modifier<span></span></button>
      </div>
    }
    @for (shippingAdr of shippingAddress; track shippingAdr; let index = $index) {
      <div class="item">
        <app-address-card [shippingAddress]="shippingAdr" [billAddress]="false" [index]="index" [label]="'Adresse de livraison'" [displayButton]="true"></app-address-card>
      </div>
    }
    @if (shippingAddress.length < 3) {
      <div class="item">
        <app-address-card [label]="'Nouvelle adresse de livraison'" [billAddress]="true" [displayButton]="true"></app-address-card>
      </div>
    }
  </div>
